import axios, { AxiosError } from 'axios';
import * as React from 'react';
import { requestRemoveListContacts } from '../asyncHelpers/listsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncRemoveListContacts
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestRemoveListContacts HTTP request
 */
export default function useAsyncRemoveListContacts() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncRemoveListContacts = async (
        listId: number,
        contactIds: number[],
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestRemoveListContacts(listId, contactIds, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    const error = e as AxiosError;
                    if (e.response?.status == 400) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }
                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncRemoveListContacts,
    };
}
